import { Icon } from '@aibees/shared/components';
import { SHARED_ROUTES as R } from '@aibees/shared/constants/routes';
import { useAddCardMutationApi } from '@aibees/shared/features/billing-profile/api/use-add-card-mutation-api';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { AddCardFailed } from './components/add-card-failed';
import { AddCardSuccess } from './components/add-card-success';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentMethodHeaderProps as Props } from './types';

export const PaymentMethodHeader = memo(({ className }: Props) => {
  const { mutateAsync } = useAddCardMutationApi();

  const handleAddCard = () => {
    mutateAsync({
      redirect: {
        success: `${window.origin + R.billing}#${'successAddCard'}`,
        failed: `${window.origin + R.billing}#${'failedAddCard'}`,
      },
    });
  };
  return (
    <Styled.Wrapper
      className={classnames('PaymentMethodHeader', className)}
      sx={SX.root}
    >
      <AddCardSuccess />
      <AddCardFailed />
      <Stack direction="row" gap={0.5}>
        <Icon name="credit-card-outlined" size={20} color="grey.700" />
        <Stack>
          <Typography variant="body4" fontWeight={500} color="grey.500">
            Payment Methods
          </Typography>
          <Typography variant="body5" fontWeight={400} color="grey.500">
            Manage your payment method for Billing
          </Typography>
        </Stack>
      </Stack>
      <Button
        variant="outlined"
        size="small"
        color="default"
        startIcon={<Icon name="plus" size={20} />}
        onClick={handleAddCard}
      >
        Add Payment Card
      </Button>
    </Styled.Wrapper>
  );
});

PaymentMethodHeader.displayName = 'PaymentMethodHeader';
